import { Component } from "@angular/core";
import { FieldWrapper, FormGlobalService } from "@kre-form/core";
import { KreFormAntService } from "../tools/service";
import * as _ from "lodash";
@Component({
  selector: "krefield-wrapper",
  template: `
    <ng-container *ngIf="formStatus !== 0; else formControl">
      <label
        nz-checkbox
        [(ngModel)]="field.checked"
        (ngModelChange)="fieldCheckChange($event)"
        [nzDisabled]="
          !!field.editProperty &&
          field.editProperty.canMove !== undefined &&
          field.editProperty.canMove === false
        "
      ></label>
      <div class="fieldbox">
        <div
          class="fieldlabel"
          [ngStyle]="{
            color: fontProperty.color,
            'font-size': fontProperty.fontSize + 'px',
            'font-style': fontProperty.fontStyle ? 'italic' : 'normal',
            'font-weight': fontProperty.fontWeight ? 'bold' : 'normal'
          }"
        >
          <span *ngIf="to.required">*</span>
          <label
            [innerHtml]="to.label | safeHtml"
            nz-tooltip
            [nzTooltipTitle]="to.label"
          ></label>
        </div>
        <div
          class="field-content-box"
          [class.field-has-button]="
            to.button && to.button != null && to.button?.show == true
          "
        >
          <div class="fieldcontrol " [ngStyle]="contentStyle()">
            <ng-template #fieldComponent></ng-template>
          </div>
          <div
            class="field-unit"
            *ngIf="to.unit && to.unit != null && to.unit != ''"
          >
            <label [innerHtml]="to.unit | safeHtml"></label>
          </div>
          <div
            class="field-button"
            *ngIf="to.button && to.button != null && to.button?.show == true"
          >
            <label
              [innerHtml]="to.button.label | safeHtml"
              (click)="buttonClick()"
            ></label>
          </div>
          <kreform-fieldbutton
            [field]="field"
            (buttonClick)="fieldOperational($event)"
            *ngIf="showFieldButton()"
          ></kreform-fieldbutton>
          <div class="field-hide" *ngIf="field.hide == true">已隐藏</div>
        </div>
      </div>
    </ng-container>
    <ng-template #formControl>
      <div
        class="fieldlabel"
        [ngStyle]="{
          color: fontProperty.color,
          'font-size': fontProperty.fontSize + 'px',
          'font-style': fontProperty.fontStyle ? 'italic' : 'normal',
          'font-weight': fontProperty.fontWeight ? 'bold' : 'normal'
        }"
        *ngIf="
          field.type != 'line' &&
          field.type != 'htmlcontent' &&
          to.hideLabel !== true
        "
      >
        <span *ngIf="to.required">*</span
        ><label [innerHtml]="to.label | safeHtml"></label>
      </div>
      <div
        class="field-content-box"
        [class.field-has-button]="
          to.button && to.button != null && to.button?.show == true
        "
      >
        <div
          class="fieldcontrol"
          [class.has-error]="showError"
          [class.inherit]="contentStyle()"
          [ngStyle]="contentStyle()"
        >
          <ng-template #fieldComponent></ng-template>
          <div class="invalid-feedback" [style.display]="'block'">
            <kreform-validation-message
              *ngIf="showError"
              style="color:red"
              [field]="field"
            ></kreform-validation-message>
          </div>
          <ng-container *ngIf="tags.mark">
            <span [nzTooltipTitle]="tags.content" nz-tooltip class="field-tags">
              {{ tags.mark | tags }}
            </span>
          </ng-container>
        </div>
        <div
          class="field-unit"
          *ngIf="to.unit && to.unit != null && to.unit != ''"
        >
          <label [innerHtml]="to.unit | safeHtml"></label>
        </div>
        <div
          class="field-button"
          *ngIf="to.button && to.button != null && to.button?.show == true"
        >
          <label
            [innerHtml]="to.button.label | safeHtml"
            (click)="buttonClick()"
          ></label>
        </div>

        <div class="field-tips" *ngIf="hasTips()">
          <i
            nz-icon
            nzType="question-circle"
            nzTheme="outline"
            nz-tooltip
            [nzTooltipTitle]="to.tips"
          ></i>
        </div>
      </div>
    </ng-template>
  `,
})
export class KreFormWrapperFormField extends FieldWrapper {
  service: any;
  constructor(
    dyService: KreFormAntService,
    private globalService: FormGlobalService
  ) {
    super();
    if (
      this.field &&
      (this.field.checked === undefined || this.field.checked == null)
    ) {
      this.field.checked = false;
    }

    this.service = dyService;
  }
  // label():string{
  //   console.log(this.to.lang , this.to)
  //   let label = this.to.label;
  //   if(!!this.to.labelI18n && this.to.labelI18n.length > 0  ) {

  //   }
  //   return label;
  // }

  fieldOperational(sign: string) {
    this.service.fieldOperational(sign, this.field);
  }
  contentStyle(): object {
    return this.to.style || {};
  }
  buttonClick() {
    this.globalService.notifyDataChanged("FieldWrapperClick", {
      rdm: Math.random(),
      config: this.field,
    });
  }
  hasTips(): string {
    if (!_.isEmpty(this.to.tipsI18n)) {
      let lang = this.to.lang || "zh-cn";
      (this.to as any)!.tips = (this.to as any)!.tipsI18n!.filter(
        (el: any) => el.language === lang
      )[0]["value"];
    }
    return (this.to as any)!.tips;
  }

  fieldCheckChange(e: any) {}
  showFieldButton(): boolean {
    let showFieldButton = true;
    if (!!this.to && this.to.showFieldButton === false) {
      showFieldButton = false;
    }
    return showFieldButton;
  }
}
